const quotes = [
  {
    id: 1,
    text: "Chuck Norris doesn’t use a 3D printer. He just stares at a block of plastic until it shapes itself. 😎🖨️"
  },
  {
    id: 2,
    text: "Chuck Norris once 3D printed a working 3D printer... using a rock and pure intimidation."
  },
  {
    id: 3,
    text: "Normal printers jam. 3D printers jam. Chuck Norris jams printers into black holes."
  },
  {
    id: 4,
    text: "Chuck Norris doesn’t design 3D models. The models reshape themselves out of respect."
  },
  {
    id: 5,
    text: "Most people slice models for 3D printing. Chuck Norris slices reality."
  },
  {
    id: 6,
    text: "Chuck Norris doesn’t use PLA, ABS, or resin — he prints directly with solid steel... and his bare hands."
  },
  {
    id: 7,
    text: "When Chuck Norris 3D prints something, it materializes instantly — time knows better than to make him wait."
  }
];

export default quotes;
